<template lang="pug">

  section.container.error-page.fill-height

    v-row(class="text-center" justify="center")

      v-col(cols="auto")

        h1(class="px-5 py-2 text-h4 mb-9" style="color: #FFFFFF")
          b Acesso ao Meu SOS indisponível

        p(class="mb-9" style="color: #FFFFFF; max-width: 480px")
          | O acesso ao portal Meu SOS foi desativado para os seus grupos. Para mais informações, entre em contato com o gestor da sua equipe.

        v-btn(depressed @click="handleLogout")
          | Sair da conta

</template>

<script>

  import { apiLogout } from '@/services/index.js'

  export default {
    name: 'MeuPortalBlocked',

    methods: {
      async handleLogout () {
        await apiLogout()
        this.$router.push('/login').catch(() => {})
      },
    },
  }

</script>

<style lang="scss" scoped>

  .error-page {
    h1 {
      font-size: 2.5rem;
    }
  }

</style>
